import { render, staticRenderFns } from "./collection-agent-phone.vue?vue&type=template&id=2aac0176"
import script from "./collection-agent-phone.vue?vue&type=script&lang=ts"
export * from "./collection-agent-phone.vue?vue&type=script&lang=ts"
import style0 from "./collection-agent-phone.vue?vue&type=style&index=0&id=2aac0176&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports